import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthRequest, LoginRequest } from "../../models/login-request";
import { OtpRequest } from '../../models/otp-request';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../environments/environments';
const AUTH_API = `${String(environment.baseUrl || '').replace(/\/+$/, '')}/sc/api/auth`;

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public defaultHeaders = new HttpHeaders();
  private authUrl = `${environment.authBaseUrl}/auth/login`;

  constructor(
    private http: HttpClient
    , private cookie: CookieService
  ) { }

  logout() {
    return this.http.get<any>(AUTH_API + '/logout');
  }

  loginldap(authRequest: AuthRequest): Observable<any> {
    return this.http.post<any>(this.authUrl, authRequest);
  }

  login(request: LoginRequest) {
    const authType = "JWT";
    const headers = request ? new HttpHeaders({
      'Authorization': 'Basic ' + btoa(request.username + ':' + request.password),
      'authType': authType
    }) : new HttpHeaders();

    return this.http.post<any>(AUTH_API, {}, { headers: headers });
  }



  sendOtp(url, request: OtpRequest): any {
    return this.http.post(url, request);
  }

  resendOtp(url, request: OtpRequest): any {
    return this.http.post(url, request);
  }

  verifyOtp(url, request: OtpRequest): any {
    return this.http.post(url, request);
  }

  oauth() {
    return this.http.get("/api/oauth");
  }

  refreshToken(token: string) {
    return this.http.get(AUTH_API + '/refreshToken?refreshToken=' + token, {
      headers: { skipAuthHeaders: 'true' }
    });
  }

  isLoggedIn(): boolean {
    if (this.cookie.get('accessToken')) {
      return true;
    }
    return false;
  }
}
